
export const countryCodeStyleDesktop= {
    control: (base, state) => ({
        ...base,
        background: 'transparent',
        borderRadius: '0px',
        borderWidth: '0px',
        boxShadow: 'none',
        ":hover": {
            borderColor: '#ccc',
        },
    }),
    valueContainer: (base, state) => ({
        ...base,
        padding: '10px 10px 10px 10px ',
    }),
    input: (base, state) => ({
        ...base,
        paddingBottom: '0px',
        paddingTop: '0px',
        margin: '0px',
    }),
    indicatorsContainer: (base, state) => ({
        ...base,
        display: 'none',
    }),
    menu: (base, state) => ({
        ...base,
        marginTop: '1px',
    }),
}


export const countryCodeStyleMobile = {
    container: (base, state) => {
        if (!state?.selectProps?.menuIsOpen) {
            setOptionsSlide(false)
        }
        return ({
            ...base,
            position: "revert",
        })
    },
    control: (base, state) => ({
        ...base,
        border: '1px solid #ccc',
        background: 'f8f8f8',
        borderRadius: '0px',
        minHeight: '42px',
        marginTop: '20px',
        marginRight: '5px',
        marginLeft: '5px',
        paddingLeft: '10px',
        boxShadow: 'none',
        ":hover": {
            borderColor: '#ccc',
        },
    }),
    valueContainer: (base, state) => ({
        ...base,
        padding: '0px 0px',
        overflow: "visible",
    }),
    placeholder: (base, state) => ({
        ...base,
        padding: '10px',
        overflow: "visible",
    }),
    input: (base, state) => ({
        ...base,
        paddingBottom: '0px',
        paddingTop: '0px',
        margin: '0px',
    }),
    indicatorsContainer: (base, state) => ({
        ...base,
        display: 'none',
    }),
    menu: (base, state) => {
        setTimeout(() => setOptionsSlide(true), 100)
        return ({
            // ...base,
            bottom: '0px',
            height: '78%',
            marginTop: '0px',
            position: "fixed",
            transition: 'all 1s ease',
            willChange: 'top',
            bottom: optionsSlide ? '0px' : '-150px',
            minWidth: '100%',
            backgroundColor: '#fff',
            left: '0px',
            zIndex: '9',
            padding: '0px 10px 10px 10px',
            borderRadius: '20px 20px 0px 0px',
        })
    },
}


